import type { IdvDocumentMenuItem } from '@Types/MatchIdv.interface';
import { IdvDocuments } from './idvDocumentTypeDisplay.constants';

export const IdvDocumentMenuItems: readonly IdvDocumentMenuItem[] = Object.freeze([
    {
        docType: IdvDocuments.NorthAmericanDriversLicense,
        description: 'Real ID, Enhanced ID, Learner\'s permit, Military ID, Non-driver state ID',
        subtext: 'US, Canada, and Mexico only',
    },
    {
        docType: IdvDocuments.Passport,
        description: 'Passport booklet, Visa',
        subtext: 'Any country',
    },
    {
        docType: IdvDocuments.UsPassportCard,
        description: 'US Passport Card (wallet-size card, not the passport booklet)',
        subtext: 'US only',
    },
    {
        docType: IdvDocuments.Other,
        description: 'International passport card, trusted traveler card, permanent resident card',
        subtext: 'Any country',
    },
]);
